// src/constants/navigation.js

import {
  LayoutDashboard,
  BookOpen,
  ClipboardList,
  Video,
  FileText,
  Lightbulb,
  Briefcase,
  Users,
  BarChart2,
  KeyRound,
  CreditCard,
  Plug,
  GraduationCap,
  TrendingUp,
  House,
} from "lucide-react";

import { ROLES } from "./UserRoles";

const getNavItems = (userRole, diverSidebarClasses = []) => {
  const dc = diverSidebarClasses;

  const NAV_BY_ROLE = {
    candidate: [
      {
        display: "Home",
        key: "dashboard",
        path: "/dashboard",
        icon: House,
        className: dc[0],
      },
      {
        display: "Preparation",
        key: "preparation",
        path: "/preparation",
        icon: BookOpen,
        className: dc[1],
      },
      {
        display: "Mock Test",
        key: "test",
        path: "/test",
        icon: ClipboardList,
        className: dc[2],
      },
      {
        display: "Mock Interview",
        key: "mock-interview",
        path: "/mock-interview",
        icon: Video,
      },
      {
        display: "CV Optimizer",
        key: "cv-optimizer",
        path: "/cv-optimizer",
        icon: FileText,
      },
      {
        display: "AI Job Insights",
        key: "insights",
        path: "/insights",
        icon: Lightbulb,
        className: dc[3],
      },
      {
        display: "Find Jobs",
        key: "jobs",
        path: "/jobs",
        icon: Briefcase,
        className: dc[4],
      },
    ],

    [ROLES.global_admin]: [
      {
        display: "Dashboard",
        key: "dashboard",
        path: "/global-admin/dashboard",
        icon: LayoutDashboard,
      },
      {
        display: "Candidates",
        key: "candidates",
        path: "/global-admin/candidates",
        icon: Users,
      },
    ],

    [ROLES.org_admin]: [
      {
        display: "Home",
        key: "dashboard",
        path: "/org-admin/dashboard",
        icon: House,
      },

      {
        display: "Students",
        key: "students",
        path: "/org-admin/batches",
        icon: Briefcase,
      },
      {
        display: "Preparation Guides",
        key: "preparationGuides",
        path: "/org-admin/preparation-guides",
        icon: KeyRound,
      },

      {
        display: "Mock Interviews",
        key: "mockInterviews",
        path: "/org-admin/mock-interviews",
        icon: CreditCard,
      },
      {
        display: "Jobs Insight",
        key: "jobs",
        path: "/org-admin/jobs",
        icon: Briefcase,
      },
    ],

    [ROLES.b2b_candidate]: [
      {
        display: "Home",
        key: "dashboard",
        path: "/b2b-candidate/dashboard",
        icon: House,
        className: dc[0],
      },
      {
        display: "Preparation",
        key: "preparation",
        path: "/b2b-candidate/preparation",
        icon: BookOpen,
        className: dc[1],
      },
      // {
      //   display: "Mock Test",
      //   key: "test",
      //   path: "/b2b-candidate/test",
      //   icon: ClipboardList,
      //   className: dc[2],
      // },
      {
        display: "Mock Interview",
        key: "mock-interview",
        path: "/b2b-candidate/mock-interview",
        icon: Video,
      },
      {
        display: "CV Optimizer",
        key: "cv-optimizer",
        path: "/cv-optimizer",
        icon: FileText,
      },
      // {
      //   display: "AI Job Insights",
      //   key: "insights",
      //   path: "/b2b-candidate/insights",
      //   icon: Lightbulb,
      //   className: dc[3],
      // },
      {
        display: "Find Jobs",
        key: "jobs",
        path: "/b2b-candidate/jobs",
        icon: Briefcase,
        className: dc[4],
      },
    ],
  };

  return NAV_BY_ROLE[userRole] ?? [];
};

export default getNavItems;
